import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';
import {Chat} from '../models/chat.model';
import { MessageThread } from '../models/messageThread.model';
@Injectable({
  providedIn: 'root'
})
export class ChatService {

  constructor(private http: HttpClient) { }
  getChat(): Observable<any> {
    return this.http.get<any>(`${environment.url}/chat`);
  }
  getCustomerMessageNotReplied(): Observable<any> {
    return this.http.get<any>(`${environment.url}/chat/customerMessageNotReplied`);
  }
  getAllCustomerMessages(): Observable<any> {
    return this.http.get<any>(`${environment.url}/chat/findAllBySender`);
  }
  saveChat(chat: Chat) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/chat`, chat, {'headers': headers});
  }

  saveReplyedChat(chat: MessageThread) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/chat`, chat, {'headers': headers});
  }

   updateChat(chat: Chat) {
    return this.http.put<any>(`${environment.url}/chat/` + chat.id, chat);
  }
  getChatById(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<Chat>(`${environment.url}/chat/` + idA);
  }

  userHistory(idUser: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/chat/userHistory/` + idUser, {'headers' : headers});
  }

  deleteChat(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/chat/` + idA, {'headers': headers});
  }

  // load chat messages
  loadChatMessages(){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/chat/allChat`, {'headers' : headers});
  }

  getChatNotification(userID:any):Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/notification/chat/userID/${userID}`,{'headers': headers});
  }

  //api/chat/reply
  replyChatNotifications(chat: MessageThread){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/chat/reply`, chat, {'headers' : headers});
  }

}
